// extracted by mini-css-extract-plugin
export default {"dropdownTag":"HFGci4","selected":"jFnbpS","selectorButton":"FETdnq"};